<hr class="line" [ngStyle]="{ background: newColor }" />

<app-topnav [pagename]="reportName" [clientLogo]="clientLogo"></app-topnav>

<app-powerbi-report-viewer
  [showHeader]="false"
  backMode="moduleDashboard"
  (reportNameChange)="reportName = $event"
></app-powerbi-report-viewer>
